<header class="page-header">
  <srm-breadcrumbs />
  <div class="page-header__content">
    <div class="page-header__heading">
      <h1>{{ pageTitle }}</h1>
      @if (pageSubtitle) {
        <p>{{ pageSubtitle }}</p>
      }
    </div>

    <div class="page-header__actions">
      @if (secondaryButtonConfig) {
        <srm-button
          type="secondary"
          [config]="secondaryButtonConfig"
          (buttonClick)="onSecondaryButtonClick()"
        ></srm-button>
      }

      @if (buttonConfig) {
        <srm-button [config]="buttonConfig" (buttonClick)="onButtonClick()"> </srm-button>
      }
    </div>
  </div>
</header>
